import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/cpcic-admin-release/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BasicLayout from '@/layouts/basic-layout';
var meta = {
  auth: true
};
var pre = 'meeting-';
export default {
  path: '/meeting',
  name: 'meeting',
  redirect: {
    name: "".concat(pre, "meeting-list")
  },
  meta: meta,
  component: BasicLayout,
  children: [{
    path: 'meeting-list',
    name: "".concat(pre, "meeting-list"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '大会',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/meeting-list');
    }
  }, {
    path: 'hotel',
    name: "".concat(pre, "hotel"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '酒店',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/hotel');
    }
  }, {
    path: 'company',
    name: "".concat(pre, "company"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '单位',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/company');
    }
  }, {
    path: 'member',
    name: "".concat(pre, "member"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '成员',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/member');
    }
  }, {
    path: 'schedule',
    name: "".concat(pre, "schedule"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '日程',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/schedule');
    }
  }, {
    path: 'venue-layout',
    name: "".concat(pre, "venue-layout"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '会场布局',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/venue-layout');
    }
  }, {
    path: 'resources',
    name: "".concat(pre, "resources"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '资源',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/resources');
    }
  }, {
    path: 'sign-up',
    name: "".concat(pre, "sign-up"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '报名',
      closable: false
    }),
    component: function component() {
      return import('@/pages/meeting/sign-up');
    }
  }]
};